import { Fragment } from 'react';
import { AccordionContainer } from './string-panel-accordion.styles';

interface Props {
  panels: JSX.Element[];
  className?: string;
}

export function StringPanelAccordion(props: Props) {
  return (
    <AccordionContainer className={props.className} id='accordion-container'>
      <Fragment>{props.panels}</Fragment>
    </AccordionContainer>
  );
}
